import { render } from "./commandes.vue?vue&type=template&id=e95bc814"
import script from "./commandes.vue?vue&type=script&lang=ts"
export * from "./commandes.vue?vue&type=script&lang=ts"
script.render = render

export default script